export default "__VITE_ASSET__B$mNWLEM__"